// Редът „Общо" на решетката „Изписване": Нето и Бруто (себестойността по
// партидите/FIFO) под колоните си, лепнат за дъното на картата
// (`WorksheetTotalsRow`). Сумите са на ВСИЧКИ редове — и на неразделените
// рецепти (по партидите на съставките им, `useWriteoffStock`).
import { useTranslation } from "react-i18next";
import {
  TotalsBlankCell,
  TotalsLabelCell,
  TotalsValueCell,
  WorksheetTotalsRow,
} from "../../components/worksheet/WorksheetTotalsRow";
import { LINE_GRID_CLASS, LINE_GRID_COLUMN_COUNT, formatMoney } from "./writeoffWorksheetShared";

type Props = {
  count: number;
  totalNet: number;
  totalGross: number;
};

export const WriteoffTotalsRow = ({ count, totalNet, totalGross }: Props) => {
  const { t } = useTranslation();
  return (
    <WorksheetTotalsRow gridClass={LINE_GRID_CLASS} columnCount={LINE_GRID_COLUMN_COUNT}>
      {/* # · Продукт · Количество · Партида · Ед. цена */}
      <TotalsLabelCell span={5} title={t("inventoryPage.total")} detail={t("inventoryPage.woLinesCount", { count })} />
      <TotalsValueCell value={formatMoney(totalNet)} />
      <TotalsValueCell value={formatMoney(totalGross)} strong />
      {/* Бележка · действия */}
      <TotalsBlankCell span={2} last />
    </WorksheetTotalsRow>
  );
};

export default WriteoffTotalsRow;
